<template>
    <div>
        <modal-x :show="isSelectingImage" @onclose="isSelectingImage=false">
            <image-list v-if="isSelectingImage" :user-id="shopUserId" @onselect="onImgSelect"></image-list>
        </modal-x>
        <modal-x :show="showCats" :content-style="{ maxWidth: '800px' }" @onclose="showCats = false">
            <category-tree v-if="showCats" :selected="selectedCatIds" :cat-node="catNode"
                v-on:catSelected="catSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        <modal-x :show="showTags" :content-style="{ maxWidth: '800px' }" @onclose="showTags = false">
            <category-tree v-if="showTags" :selected="selectedTagIds" :cat-node="tagNode"
                v-on:catSelected="tagSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        <div>
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    <div>
                        Image:
                        <img :src="retObj.image" style="width:100px;height:100px;" />
                        <div class="input-group">
                            <input class="form-control" type="text" v-model="retObj.image" />
                            <span class="input-group-btn">
                                <button class="btn btn-default" type="button" @click="selectImg(setNewLabelImg)">Select
                                    Image</button>
                            </span>
                        </div>
                    </div>
                    <div>
                        <span style="float:left;font-size:16px;">Title</span>
                        <input class="form-control" type="text" v-model="retObj.title" />
                        <span style="float:left;font-size:16px;">Message</span>
                        <textarea class="form-control" type="text" v-model="retObj.msg"></textarea>
                    </div>
                    <div class="col-xs-12" style="text-align:right;">
                        <span class="btn btn-default" @click="editCats">Select Categories</span>
                        <span class="btn btn-default" @click="editTags">Select Tags</span>
                    </div>
                    <div class="col-xs-12">
                        <div class="col-xs-6">
                            Category SubType
                            <select v-model.number="retObj.catSubType" class="form-control">
                                <option value="-1">Please Select</option>
                                <option value="0">Product Page</option>
                                <option value="1">Article Page</option>
                            </select>
                        </div>
                        <div class="col-xs-6">
                            Card View
                            <select v-model="retObj.cardView" class="form-control">
                                <option value="">Please Select</option>
                                <option value="info">Info</option>
                                <option value="infoText">Info Text</option>
                                <option value="sale">Sale</option>
                                <option value="text">Text</option>
                                <option value="banner">Banner</option>
                                <option value="bigBanner">Big Banner</option>
                                <option value="link">Link</option>
                                <option value="media">Media</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="col-xs-6">
                            <div>Page Size</div>
                            <input class="form-control" type="number" v-model.number="retObj.pageSize" />
                        </div>
                        <div class="col-xs-6">
                            <div>Default Page (when there is no paging buttons)</div>
                            <input class="form-control" type="number" v-model.number="retObj.page" />
                        </div>
                    </div>

                    <div class="col-xs-12">
                        <div class="col-xs-6">Hide Paging: <input class="form-control" style="width:100px;"
                                type="checkbox" v-model="retObj.hidePaging" /> </div>
                        <div class="col-xs-6">Get Links: <input class="form-control" style="width:100px;"
                                type="checkbox" v-model="retObj.getLinks" /> </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    {{ retObj }}
                </div>
            </div>
        </div>
        <div><input type="button" class="btn btn-default" @click="save" value="Done" /></div>
    </div>
</template>
<script>
import CategoryTree from '../components/CategoryTree.vue';
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import apis from '../api/extApi.js';

export default {
    components: {
        CategoryTree: CategoryTree,
        imageList: imageList,
        modalX: modalX
    },
    props: ["shopUserId", "initData"],
    computed: {

    },
    data: function () {
        return {
            apiClient: apis.api,
            catCodes: apis.api.settings.catCodes,
            uiClient: null,
            imgHandler: null,
            isSelectingImage: false,
            selectedImgs: [],
            retObj: this.initData === null ? {} : this.initData,
            selectedCatIds: { catIds: [], timestamp: 0 },
            selectedTagIds: { catIds: [], timestamp: 0 },
            showCats: false,
            catNode: null,
            showTags: false,
            tagNode: null
        };
    },
    methods: {
        save: function () {
            this.$emit("onsave", this.retObj);
        },
        getArrayFromCsv: function (val) {
            if (val && val !== null) {
                return val.split(',');
            }
            return [];
        },
        editTags: function () {
            this.apiClient.getCategoryNodePrms(this.catCodes.tag, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.tagNode = ret;
                this.showTags = true;
            });

        },
        tagSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.tags;
            if (!catIds) {
                catIds = [];
                this.retObj.tags = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.tags.splice(index, 1);
            } else {
                this.retObj.tags.push(ret.child.catId);
            }
            this.selectedTagIds.catIds = this.retObj.tags;
            this.selectedTagIds.timestamp = Date.now();
        },
        catSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.cats;
            if (!catIds) {
                catIds = [];
                this.retObj.cats = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.cats.splice(index, 1);
            } else {
                this.retObj.cats.push(ret.child.catId);
            }
            this.selectedCatIds.catIds = this.retObj.cats;
            this.selectedCatIds.timestamp = Date.now();
        },
        editCats: function () {
            this.apiClient.getCategoryNodePrms(this.catCodes.listing, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.catNode = ret;
                this.showCats = true;
            });
        },
        onImgSelect: function (imgFile) {
            this.selectedImgs.push(imgFile);
            this.imgHandler(imgFile, this.selectedImgs);
        },
        setNewLabelImg: function (newImg) {
            this.retObj.image = newImg.thumbPath;
            this.isSelectingImage = false;
        },
        selectImg: function (handler) {
            this.imgHandler = handler;
            this.isSelectingImage = !this.isSelectingImage;
        }
    },
    created: function () {

    },
    mounted: function () {
        console.log("jsonData userid", this.shopUserId);
        if (this.retObj.cats) {
            this.selectedCatIds.catIds = this.retObj.cats;
            this.selectedCatIds.timestamp = Date.now();
        }
        this.uiClient = apis.ui.getShopClient({ userId: this.shopUserId });
    },
    destroyed: function () {
        this.uiClient.destroy();
    }
}
</script>